import { useEffect } from "react";
import { usePatchPortfolioPensionProductsMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPortfolioPensionProductsMutation";
import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getPortfolioTitle } from "web_myplann/Portfolio/Components/PortfolioSections/portfolioListItemHelpers";
import { mapPortfolioToPensionForm } from "web_myplann/Portfolio/Forms/PensionForm/mapPortfolioToPensionForm";
import { getPensionFormSchema } from "web_myplann/Portfolio/Forms/PensionForm/pensionFormSchema";
import { useEditPortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useEditPortfolioForm";

type UseEditPensionFormArgs = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const useEditPensionForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: UseEditPensionFormArgs) => {
	const { t } = useResource();
	const { mutate, isPending } =
		usePatchPortfolioPensionProductsMutation(portfolioId);

	const { form, onSubmit } = useEditPortfolioForm({
		schema: getPensionFormSchema(t),
		defaultValues: mapPortfolioToPensionForm(portfolio),
		mutate,
		successToast: t(Resources.Portfolio.EditPortfolio.savedToast, {
			type: getPortfolioTitle(portfolio, t),
		}),
		redirectTo: detailRoute,
	});

	useEffect(() => {
		form.trigger();
	}, [form.trigger]);

	return { form, onSubmit, isPending };
};
